module.exports = __webpack_public_path__ + "img/cns_email_android2.7f4dbe7c.png";